/**
 * Réserve horizontale pour le centre d'aide — alignée sur HelpPanel (sidebarShell).
 * w-[min(25vw,540px)] min-w-[300px] => largeur effective = max(300px, min(25vw, 540px))
 */
export const HELP_PANEL_RESERVE_CSS = 'max(300px, min(25vw, 540px))';
